import { render, staticRenderFns } from "./PollyVoiceSelect.vue?vue&type=template&id=52f1b4f1"
import script from "./PollyVoiceSelect.vue?vue&type=script&lang=ts"
export * from "./PollyVoiceSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports